import React, { useState, useEffect, Component } from 'react';
import {
  Button,
  KeyboardAvoidingView,
  Linking,
  ScrollView,
  Text,
  TextInput,
  TouchableHighlight,
  TouchableOpacity,
  View,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Autocomplete from './autocomplete';
import Styles from './styles';
import Config from './config';
import Hermes from './hermes';

const WordsURL = `${Config.Scheme}://${Config.Domain}/words`;

export default function EditWordView({ route, navigation }) {
  var id = route.params.id;
  var newWord = route.params.word;
  var [word, setWord] = useState("");
  var [source, setSource] = useState("");
  var [sources, setSources] = useState([]);
  var [sourcesHide, setSourcesHide] = useState(false);
  var [usage, setUsage] = useState("");
  var [partOfSpeech, setPartOfSpeech] = useState("");
  var [definition, setDefinition] = useState("");
  var [attributionText, setAttributionText] = useState("");
  var [attributionUrl, setAttributionUrl] = useState("");

  var textInputSource;
  var textInputPartOfSpeech;
  var textInputUsage;
  var textInputDefinition;

  const save = async () => {
    const helpWordsView = await AsyncStorage.getItem('help_words_view');
    if (helpWordsView == null) {
      await AsyncStorage.setItem('help_words_view', 'given');
      window.speechSynthesis.speak(new SpeechSynthesisUtterance("additional menu items could be found by swiping left or right on a word"));
    }

    const updated = {
      id: id,
      word: word,
      source: source,
      usage: usage,
      partOfSpeech: partOfSpeech,
      definition: definition,
    };

    if (id > 0) {
      try {
        const result = await Hermes.fetch(`${WordsURL}/${id}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: "PUT",
          body: JSON.stringify({word: updated}),
        });
      } catch(error) {
        Hermes.alert(error);
      }
    } else {
      try {
        const result = await Hermes.fetch(WordsURL, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: "POST",
          body: JSON.stringify({word: updated}),
        });
      } catch(error) {
        Hermes.alert(error);
      }
    }

    navigation.goBack();
  };

  const cancel = () => {
    navigation.goBack();
  };

  const openAttributionUrl = () => {
    if (attributionUrl === "") {
      return;
    }
    try {
      Linking.openURL(attributionUrl);
    } catch(error) {
      Hermes.alert(error);
    }
  };

  const getSources = async (query) => {
    setSource(query);

    try {
      const result = await Hermes.fetch(`${Config.Scheme}://${Config.Domain}/sources?query=${query}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "GET",
      });

      const sources = result.sources
      sources.unshift(source);
      setSources(sources.filter((v,i) => sources.indexOf(v) == i));
      setSourcesHide(false);
    } catch(error) {
      Hermes.alert(error);
    }
  };

  useEffect(async () => {
    navigation.setOptions({ title: `Edit Word` })
    if (id == 0) {
      setWord(newWord);
    } else {
      try {
        const result = await Hermes.fetch(`${WordsURL}/${id}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: "GET",
        });

        const {word, source, usage, partOfSpeech, definition, attributionText, attributionUrl} = result.word;
        setWord(word);
        setSource(source);
        setUsage(usage);
        setPartOfSpeech(partOfSpeech);
        setDefinition(definition);
        setAttributionText(attributionText);
        setAttributionUrl(attributionUrl);
      } catch(error) {
        Hermes.alert(error);
      }
    }
  }, []);

  return (
    <View style={Styles.container}>
     <View style={{flex: 1, marginTop: 22}}>
      <KeyboardAvoidingView behavior={'height'} style={Styles.modal}>
        <ScrollView keyboardShouldPersistTaps='always'>
          <TextInput
            style={Styles.input}
            onChangeText={(value) => setWord(value)}
            value={word}
            placeholder="Word"
            autoCapitalize='none'
            returnKeyType='next'
            onSubmitEditing={() => textInputSource.focus()}/>
          <Autocomplete
            style={{padding: 10, marginTop: 10, marginLeft: 10, marginRight: 10,
              height: 40, borderColor: 'gray', borderWidth: 1}}
            inputContainerStyle={{borderWidth: 0}}
            listStyle={{paddingLeft:10, paddingRight: 10, marginLeft: 10, marginRight: 10,
              height: 110, borderColor: 'gray', borderWidth: 1}}
            onChangeText={getSources}
            value={source}
            placeholder="Source"
            autoCapitalize='none'
            returnKeyType='next'
            onSubmitEditing={() => textInputUsage.focus()}
            ref={(input) => textInputSource = input}
            data={sources}
            hideResults={sourcesHide}
            renderItem={({item, index, separators}) => (
              <TouchableOpacity onPress={() => {setSourcesHide(true); setSource(item)}}
                style={{marginLeft: 10, backgroundColor: 'rgba(0,0,0,0)'}}>
                <Text>{item}</Text>
              </TouchableOpacity>
            )}/>
          <TextInput
            style={{padding: 10, margin: 10, marginTop: 20, height: 80, borderColor: 'gray', borderWidth: 1,}}
            onChangeText={(value) => setUsage(value)}
            value={usage}
            placeholder="Usage"
            autoCapitalize='none'
            blurOnSubmit={true}
            returnKeyType='next'
            onSubmitEditing={() => textInputPartOfSpeech.focus()}
            ref={(input) => textInputUsage = input}
            multiline = {true}
            numberOfLines = {8}/>
          <TextInput
            style={{padding: 10, margin: 10, height: 40, borderColor: 'gray', borderWidth: 1}}
            onChangeText={(value) => setPartOfSpeech(value)}
            value={partOfSpeech}
            placeholder="Part Of Speech"
            autoCapitalize='none'
            returnKeyType='next'
            onSubmitEditing={() => textInputDefinition.focus()}
            ref={(input) => textInputPartOfSpeech = input}/>
          <TextInput
            style={{padding: 10, margin: 10, height: 80, borderColor: 'gray', borderWidth: 1}}
            onChangeText={(value) => setDefinition(value)}
            value={definition}
            placeholder="Definition"
            autoCapitalize='none'
            blurOnSubmit={true}
            returnKeyType='done'
            onSubmitEditing={save}
            ref={(input) => textInputDefinition = input}
            multiline = {true}
            numberOfLines = {8}/>
          <TouchableHighlight
            style={{padding: 10, margin: 10, borderColor: 'gray', borderWidth: 1}}
            onPress={openAttributionUrl}>
            <Text>{attributionText}</Text>
          </TouchableHighlight>
          <View style={{padding: 10}}>
            <Button
              onPress={save}
              title="Done"
              color="#841584"
              accessibilityLabel="Saves and closes the dialog"/>
          </View>
          <View style={{padding: 10}}>
            <Button
              onPress={cancel}
              title="Cancel"
              color="#841584"
              accessibilityLabel="Cancels and closes the dialog"/>
          </View>
          <View style={{height: 40}}></View>
        </ScrollView>
      </KeyboardAvoidingView>
     </View>
    </View>
  );
};
